import React, { createContext, useEffect, useState } from "react";

export const PictureContext = createContext();

export const formatImageData = (images) => {
  const imageObject = images.map((image) => ({
    ...image,
    shortAuthor: image.author
      .slice(0, image.author.length - 2)
      .split('("')
      .pop(),
    splitTags: image.tags === "" ? (image.tags = []) : image.tags.split(" "),
    title: image.title.length < 2 ? "untitled" : image.title,
    shortDescription: image.description.split("/></a></p>").pop(),
  }));

  return imageObject;
};

export const PictureProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [pictures, setPictures] = useState([]);
  const [scrollStatus, setScrollStatus] = useState(false);
  const [search, setSearch] = useState();
  const [sfwMode, setSfwMode] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [page, setPage] = useState(0);

  const searchTerms = ['cat', 'dog', 'nature', 'city', 'food', 'travel', 'art', 'flower', 'sunset', 'ocean'];

  useEffect(() => {
    const flickrApiCall = async () => {
      if (page > 0) {
        setIsLoadingMore(true);
      }
      
      try {
        const searchTerm = searchTerms[page % searchTerms.length];
        const url = `https://corsproxy.io/?https://api.flickr.com/services/feeds/photos_public.gne?format=json&nojsoncallback=1&safe_search=1&tags=${searchTerm}`;
        const response = await fetch(url);
        let dataToJson = await response.json();
        
        if (page === 0) {
          setPictures(formatImageData(dataToJson.items));
        } else {
          setPictures(prevPictures => [...prevPictures, ...formatImageData(dataToJson.items)]);
        }
      } finally {
        setLoading(false);
        setIsLoadingMore(false);
      }
    };
    flickrApiCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollStatus, page]);

  const getTags = (tagArray, maxNumberOfTags) => {
    return maxNumberOfTags > 0 ? tagArray.slice(0, maxNumberOfTags) : tagArray;
  };

  return (
    <PictureContext.Provider
      value={{
        loading,
        pictures,
        search,
        sfwMode,
        isLoadingMore,
        getTags,
        setPictures,
        setScrollStatus,
        setSearch,
        setSfwMode,
        setPage,
      }}
    >
      {children}
    </PictureContext.Provider>
  );
};

export const usePictureContext = () => {
  return React.useContext(PictureContext);
};
